// import { useState, useEffect } from 'react';
// import Wrapper from '../assets/wrappers/Floors';
// import { FormRow, FloorRow } from '../components';

// export const loader = async ({ params }) => {
//   try {
//     const { data } = await customFetch(`/buildings/${params.id}`);
//     return data;
//   } catch (error) {
//     toast.error(error.response?.data?.msg);
//     return redirect("/dashboard/all-buildings");
//   }
// };

// export const action = async ({ request, params }) => {
//   const formData = await request.formData();
//   const data = Object.fromEntries(formData);

//   if (data.maintenanceCompany === "undefined" || data.maintenanceCompany === "")
//     delete data.maintenanceCompany;

//   try {
//     await customFetch.patch(`/buildings/${params.id}`, data);
//     toast.success("הבניין עודכן בהצלחה");
//     return redirect("/dashboard/all-buildings");
//   } catch (error) {
//     toast.error(error?.response?.data?.msg);
//     return error;
//   }
// };

// const AddFloors = () => {
//   const initialFormState = {
//     floorName: '',
//     startFloor: '',
//     endFloor: '',
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [dummyData, setDummyData] = useState([]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const start = parseInt(formData.startFloor);
//     const end = parseInt(formData.endFloor);

//     if (start < end) {
//       const floors = [];
//       for (let i = start; i <= end; i++) {
//         floors.push({ id: i, floorName: `Floor ${i}`, floorNumber: i });
//       }
//       setDummyData(floors);
//     } else {
//       console.error('Start floor must be less than end floor.');
//     }
//   };

//   useEffect(() => {
//     console.log('Fetching data...');
    
//     setTimeout(() => {
//       console.log('Data fetched');
//     }, 1000);
//   }, []);

//   return (
//     <>
//       {dummyData.length === 0 && (
//         <Wrapper>
//           <form className='form' onSubmit={handleSubmit}>
//             <h4 className='form-title'>הוספת קומות אוטומטית</h4>
//             <div className='form-center'>
//               <FormRow
//                 labelText='קומת התחלה'
//                 type='text'
//                 name='startFloor'
//                 value={formData.startFloor}
//                 handleChange={handleChange}
//               />

//               <FormRow
//                 type='text'
//                 name='endFloor'
//                 labelText='הקומה האחרונה'
//                 value={formData.endFloor}
//                 handleChange={handleChange}
//               />

//               <div className='btn-container'>
//                 <button type='submit' className='btn btn-primary'>
//                   הוסף קומה
//                 </button>
//                 <button
//                   type='button'
//                   className='btn btn-primary clear-btn'
//                   onClick={() => setFormData(initialFormState)}
//                 >
//                   נקה טופס
//                 </button>
//               </div>
//             </div>
//           </form>
//         </Wrapper>
//       )}

//       {dummyData.length > 0 && (
//         <Wrapper>
//           <div className='form'>
//             <h4 className='form-title'>ניהול קומות</h4>
//             <div className='form-center'>
//               {dummyData.map((floor) => (
//                 <FloorRow
//                   key={floor.id}
//                   floorName={floor.floorName}
//                   floorNumber={floor.floorNumber}
//                 />
//               ))}
//             </div>
//           </div>
//         </Wrapper>
//       )}
//     </>
//   );
// };

// export default AddFloors;

import React, { useState, useEffect } from "react";
import { useParams, redirect  } from "react-router-dom";
import { Collapse, Button, Input, Modal, Select, Form, Space, List, Spin } from "antd";
import { PlusOutlined, DeleteOutlined, ExclamationCircleOutlined, EditOutlined } from "@ant-design/icons";
import { customFetch } from "../utils/custom-fetch.js";
import { toast } from "react-toastify";
import Wrapper from "../assets/wrappers/DashboardFormPage";

const { Panel } = Collapse;
const { Option } = Select;
const { confirm } = Modal;
const directions = ["ימין", "שמאל", "ישר", "אחורה"];

// הקפד על השארת ה-loader שלך! הוא כאן:
export const loader = async ({ params }) => {
  try {
    
    const { data } = await customFetch(`/floors-navigation/${params.floorNavigationId}`);
    return data;
  } catch (error) {
    toast.error(error.response?.data?.msg);
    return redirect("/dashboard/all-office");
  }
};

const FloorNavigationManager = () => {
  const { floorNavigationId } = useParams();
  const [floors, setFloors] = useState([]);
  const [startFloor, setStartFloor] = useState("");
  const [endFloor, setEndFloor] = useState("");
  const [businessName, setBusinessName] = useState({});
  const [businessDirection, setBusinessDirection] = useState({});
  const [editingFloorName, setEditingFloorName] = useState({});
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (!floorNavigationId) {
      toast.error("לא נמצא מזהה מערכת (floorNavigationId) ב-URL");
      setInitialLoading(false);
      return;
    }
    fetchFloors();
    // eslint-disable-next-line
  }, [floorNavigationId]);

  const fetchFloors = async () => {
    setInitialLoading(true);
    try {
      const res = await customFetch.get(`/floors-navigation/${floorNavigationId}`);
      setFloors(res.data.floors || res.data.floorNavigation?.floors || []);
    } catch (err) {
      toast.error("שגיאה בטעינת הקומות");
    }
    setInitialLoading(false);
  };

  // יצירת קומות אוטומטית לשרת
  const generateFloors = async () => {
    if (!startFloor || !endFloor || Number(startFloor) > Number(endFloor)) {
      toast.error("יש להזין טווח קומות חוקי");
      return;
    }
    setLoading(true);
    try {
      for (let i = Number(startFloor); i <= Number(endFloor); i++) {
        await customFetch.post(`/floors-navigation/${floorNavigationId}/floors`, {
          floorNumber: i,
          floorName: `קומה ${i}`,
          businesses: [],
        });
      }
      toast.success("קומות נוצרו בהצלחה");
      fetchFloors();
    } catch (err) {
      toast.error("בעיה ביצירת הקומות");
    }
    setLoading(false);
  };

  // שינוי שם קומה (עריכה אינליין)
const handleEditFloorName = async (floorId, newName) => {
  try {
    // נניח שיש לך floors ברמת קומפוננטה
    const floor = floors.find(f => f._id === floorId);
    await customFetch.put(`/floors-navigation/${floorNavigationId}/floors/${floorId}`, {
      floorName: newName,
      floorNumber: floor.floorNumber, // זה חובה בגלל הוולידציה שלך
    });
    toast.success("שם הקומה עודכן");
    setEditingFloorName({ ...editingFloorName, [floorId]: false });
    fetchFloors();
  } catch (err) {
    toast.error("שגיאה בעדכון השם");
  }
};

  // הוספת עסק ישירות לשרת
  const handleAddBusiness = async (floorId) => {
    const name = businessName[floorId];
    const direction = businessDirection[floorId];
    if (!name || !direction) {
      toast.error("יש למלא שם עסק וכיוון");
      return;
    }
    setLoading(true);
    try {
      await customFetch.post(
        `/floors-navigation/${floorNavigationId}/floors/${floorId}/businesses`,
        { name, direction }
      );
      toast.success("עסק נוסף");
      setBusinessName({ ...businessName, [floorId]: "" });
      setBusinessDirection({ ...businessDirection, [floorId]: "" });
      fetchFloors();
    } catch (err) {
      toast.error("שגיאה בהוספת עסק");
    }
    setLoading(false);
  };

  // מחיקת עסק
  const handleDeleteBusiness = (floorId, businessId) => {
    confirm({
      title: "האם אתה בטוח שברצונך להסיר את העסק?",
      icon: <ExclamationCircleOutlined />,
      okText: "כן, מחק",
      okType: "danger",
      cancelText: "ביטול",
      async onOk() {
        setLoading(true);
        try {
          await customFetch.delete(
            `/floors-navigation/${floorNavigationId}/floors/${floorId}/businesses/${businessId}`
          );
          toast.success("העסק הוסר");
          fetchFloors();
        } catch (err) {
          toast.error("שגיאה במחיקת עסק");
        }
        setLoading(false);
      },
    });
  };

  if (initialLoading) {
    return (
      <div style={{ textAlign: "center", margin: "2rem 0" }}>
        <Spin size="large" />
        <div style={{ marginTop: 8 }}>טוען נתונים...</div>
      </div>
    );
  }

  return (
    <Wrapper>
      <h2 style={{ textAlign: "center" }}>ניהול קומות ועסקים</h2>
      <Space>
        <Input
          style={{ width: 120 }}
          placeholder="קומת התחלה"
          value={startFloor}
          onChange={(e) => setStartFloor(e.target.value)}
          type="number"
        />
        <Input
          style={{ width: 120 }}
          placeholder="קומת סיום"
          value={endFloor}
          onChange={(e) => setEndFloor(e.target.value)}
          type="number"
        />
        <Button type="primary" icon={<PlusOutlined />} loading={loading} onClick={generateFloors}>
          צור קומות
        </Button>
      </Space>
      <br /><br />
      <Collapse accordion>
        {floors.map((floor) => (
          <Panel
            header={
              <span>
                {editingFloorName[floor._id] ? (
                  <Input
                    defaultValue={floor.floorName}
                    autoFocus
                    onBlur={(e) => handleEditFloorName(floor._id, e.target.value)}
                    onPressEnter={(e) => handleEditFloorName(floor._id, e.target.value)}
                    style={{ width: 120, marginLeft: 8 }}
                  />
                ) : (
                  <>
                    {floor.floorName} <Button
                      icon={<EditOutlined />}
                      size="small"
                      type="text"
                      onClick={() => setEditingFloorName({ ...editingFloorName, [floor._id]: true })}
                    />
                  </>
                )}
                {" "}({floor.businesses?.length || 0} עסקים)
              </span>
            }
            key={floor._id}
          >
            <List
              dataSource={floor.businesses}
              renderItem={(business) => (
                <List.Item
                  actions={[
                    <Button
                      type="text"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => handleDeleteBusiness(floor._id, business._id)}
                    />,
                  ]}
                >
                  {business.name} - כיוון: {business.direction}
                </List.Item>
              )}
              locale={{ emptyText: "אין עסקים בקומה" }}
            />
            {/* הוספת עסק */}
            <Form layout="inline" style={{ marginTop: 16 }}>
              <Form.Item>
                <Input
                  placeholder="שם עסק"
                  value={businessName[floor._id] || ""}
                  onChange={(e) =>
                    setBusinessName({ ...businessName, [floor._id]: e.target.value })
                  }
                />
              </Form.Item>
              <Form.Item>
                <Select
                  placeholder="כיוון"
                  value={businessDirection[floor._id] || undefined}
                  onChange={(value) =>
                    setBusinessDirection({ ...businessDirection, [floor._id]: value })
                  }
                  style={{ minWidth: 100 }}
                >
                  {directions.map((dir) => (
                    <Option key={dir} value={dir}>
                      {dir}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  loading={loading}
                  onClick={() => handleAddBusiness(floor._id)}
                >
                  הוסף עסק
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        ))}
      </Collapse>
    </Wrapper>
  );
};

export default FloorNavigationManager;
